module.exports = __webpack_public_path__ + "assets/icons/small.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/bags/small.png
// module id = ./src/styles/icons/bags/small.png
// module chunks = 0